module.exports = "/_next/static/images/landing1-mobile-ec8a1a1d9352bd4c7e9af194e39e6f72.png";